import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_THERMOMETERS } from "../../../routes";
import { createThermometer } from "../actions/thermometersActions";
import FormPage from "../../common/components/layout/FormPage";
import CreateThermometerForm from "../components/CreateThermometerForm";

class CreateThermometer extends FormPage {
  static propTypes = {
    thermometer: shape().isRequired,
    match: shape().isRequired,
    createThermometer: func.isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * @param {object} thermometer
   */
  onSubmit(thermometer) {
    const { createThermometer, match } = this.props;
    const paramsThermometer = {
      clientUuid: match.params.uuid,
      ...thermometer,
    };

    createThermometer(paramsThermometer);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.thermometers.add.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_THERMOMETERS;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { thermometer } = this.props;

    return (
      <CreateThermometerForm
        loading={thermometer.saving}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  thermometer: state.thermometer,
});

const mapDispatchToProps = (dispatch) => ({
  createThermometer: (params) => dispatch(createThermometer(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateThermometer);
